import React from 'react';
import { useTheme } from '../ThemeContext';
import { useOnboarding } from '../OnboardingContext';

export default function Footer() {
  const { mode, toggleMode, colors } = useTheme();
  const { openOnboarding } = useOnboarding();
  const year = new Date().getFullYear();

  const pillStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 14px',
    backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
    border: `1px solid ${colors.borderColor}`,
    borderRadius: 20,
    cursor: 'pointer',
    color: colors.footerText,
    fontSize: 13,
    fontWeight: 500,
    transition: 'background-color 0.2s',
  };

  return (
    <footer style={{
      backgroundColor: colors.footerBg,
      borderTop: `1px solid ${colors.footerBorder}`,
      padding: '12px 28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
      gap: 12,
      flexWrap: 'wrap',
    }}>
      {/* Left — app name, copyright, version and disclaimer */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <span style={{ color: colors.footerText, fontSize: 13, fontWeight: 600 }}>
          Software Simulation Builder
        </span>
        <span style={{
          color: colors.amberText,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          border: `1px solid ${colors.amberText}`,
          borderRadius: 4,
          padding: '1px 6px',
        }}>
          Alpha v0.1
        </span>
        <span style={{ color: colors.footerText, fontSize: 12 }}>
          © {year} All rights reserved
        </span>
        <span style={{ color: colors.footerText, fontSize: 12 }}>
          This is an early alpha release — features may change and bugs may be present.
        </span>
        <a
          href="https://instructionaldesigner.ie"
          target="_blank"
          rel="noreferrer"
          aria-label="instructionaldesigner.ie (opens in new tab)"
          style={{
            color: colors.footerText,
            fontSize: 12,
            textDecoration: 'none',
            fontWeight: 500,
          }}
        >
          instructionaldesigner.ie ↗
        </a>
      </div>

      {/* Right — getting started + light/dark toggle */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button
          onClick={openOnboarding}
          aria-label="Open the Getting Started tour"
          title="Open the Getting Started tour"
          style={pillStyle}
        >
          💡 Getting Started
        </button>

        <button
          onClick={toggleMode}
          aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
          title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
          style={pillStyle}
        >
          {/* Toggle track */}
          <span style={{
            position: 'relative',
            display: 'inline-block',
            width: 36,
            height: 20,
            backgroundColor: mode === 'dark' ? colors.indigo : '#cbd5e1',
            borderRadius: 10,
            transition: 'background-color 0.2s',
            flexShrink: 0,
          }}>
            <span style={{
              position: 'absolute',
              top: 3,
              left: mode === 'dark' ? 18 : 3,
              width: 14,
              height: 14,
              backgroundColor: 'white',
              borderRadius: '50%',
              transition: 'left 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            }} />
          </span>
          {mode === 'dark' ? '🌙 Dark' : '☀️ Light'}
        </button>
      </div>
    </footer>
  );
}
